import { computed } from 'vue'
import { useQuery } from '@tanstack/vue-query'

import IbexaContentTypeIdentifier from '@/enums/IbexaContentTypeIdentifier'
import { createQueryKey, mapSlide } from '@/utils'
import { useCmsContentSearch } from '@/composables/useCmsContentSearch'

export const useSlide = (contentId: number) => {
  const { search } = useCmsContentSearch()

  const slideQuery = {
    ['contentTypes[]']: [
      IbexaContentTypeIdentifier.vgsSlideCoverImage,
      IbexaContentTypeIdentifier.vgsSlideTextOnly,
      IbexaContentTypeIdentifier.vgsSlideVideo,
      IbexaContentTypeIdentifier.vgsSlideSideBySide,
    ],
    ['contentId[]']: contentId.toString(),
  }

  const { data } = useQuery({
    queryKey: createQueryKey('slide', contentId),
    queryFn: () => search(slideQuery),
    staleTime: 1000 * 60 * 60 * 8,
  })

  const slide = computed(() => {
    if (!data.value) return
    return mapSlide(data.value[0])
  })

  return {
    slide,
  }
}

export default useSlide
